import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（経営情報等） 出力", -1)
const _hoisted_2 = { class: "row align-items-start justify-content-center g-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "select-tenant",
    class: "col-form-label fw-bold mb-0"
  }, [
    /*#__PURE__*/_createTextVNode("施設選択（複数選択可能）"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("※複数選択:Ctrl+クリック")
  ])
], -1)
const _hoisted_4 = { class: "col-5" }
const _hoisted_5 = ["size"]
const _hoisted_6 = ["value", "textContent"]
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "出力", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_dismissible_alert, {
        class: "mt-3",
        color: "danger",
        message: _ctx.errorMessage,
        onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = null))
      }, null, 8, ["message"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            id: "select-tenant",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
            multiple: "",
            size: _ctx.facilityPicks.length
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityPicks, (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t.facilityKey,
                value: t,
                textContent: _toDisplayString(t.hospitalClinicName)
              }, null, 8, _hoisted_6))
            }), 128))
          ], 8, _hoisted_5), [
            [_vModelSelect, _ctx.selectedFacilities]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_loading_button, {
            color: "primary",
            onClick: _ctx.onClickedExport,
            loading: _ctx.loading,
            class: "d-flex align-items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ])
    ]),
    _: 1
  }))
}